import React from "react";
import Button from '@mui/material/Button';
import { ValidateInvoiceInput } from "./ValidateInvoiceInput";
const btnsArray = [
  { operation: "Display" },
  { operation: "Change" },
  {
    operation: "Create",
    navPath: (navigate) => navigate(`/Invoice/Create`),
  },
];

export default function OverviewButtons({
  invoice,
  navigate,
  _getInvoiceExists,
  _createErrorMessage,
}) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
      }}
      className="customButton"
    >
      {btnsArray.map(({ operation, navPath }, i) => (
        <div style={{ width: "48%", marginBottom: 15 }}>
          <Button
            className="btn btn-primary w-100"
            key={operation}
            onClick={() => {
              if (operation === "Create") {
                navPath(navigate);
                return;
              }

              let validationInvoiceResult = ValidateInvoiceInput(
                invoice,
                _createErrorMessage
              );

              if (!validationInvoiceResult) {
                return;
              }

              _getInvoiceExists(
                { data: { Id: invoice } },
                ({ data: isExist }) => {
                  if (!isExist) {
                    _createErrorMessage("68");
                    return;
                  }
                  const navigationUrl = `/Invoice/${invoice}/${operation}`;
                  navigate(navigationUrl);
                }
              );
            }}
          >
            {operation}
          </Button>
        </div>
      ))}
    </div>
  );
}
